import type { GridLocaleText } from "@mui/x-data-grid-premium";
import type { TFunction } from "i18next";

/**
 * App-wide DataGrid localeText overrides. MUI replaces (not merges) the
 * theme-level localeText when a grid passes its own, so any grid that sets
 * `localeText` must spread this in to keep the shared strings.
 */
type SortDirection = "ascending" | "descending";

const getSortLabel = (
  t: TFunction,
  type: string | undefined,
  direction: SortDirection
): string => {
  if (type === "number") {
    return t(`data_grid.sort_number_${direction}`);
  }

  if (type === "string") {
    return t(`data_grid.sort_string_${direction}`);
  }

  if (type === "date" || type === "dateTime") {
    return t(`data_grid.sort_date_${direction}`);
  }

  return t(`data_grid.sort_${direction}`);
};

export const buildGridLocaleText = (t: TFunction): Partial<GridLocaleText> => ({
  filterPanelAddFilter: t("data_grid.add_filter"),
  paginationRowsPerPage: t("data_grid.pagination_rows_per_page"),
  paginationDisplayedRows: ({ from, to, count }) =>
    t("data_grid.pagination_displayed_rows", { from, to, count }),
  columnMenuSortDesc: (colDef) => getSortLabel(t, colDef.type, "descending"),
  columnMenuSortAsc: (colDef) => getSortLabel(t, colDef.type, "ascending"),
});
